// extracted by mini-css-extract-plugin
export default {"credentialForm":"StrongholdForm_credentialForm__gU202","credentialActions":"StrongholdForm_credentialActions__HVzQg"};